import { ErrorState } from "@/components/ErrorState";
import Loader from "@/components/loader/Loader";
import WithdrawContainer from "@/components/shared/withdraw/WithdrawContainer";
import { useMyWalletAndAssets } from "@/hooks";
import { useAppSelector } from "@/store/hooks";
import { getErrorMessage } from "@/utils/getErrorMessage";
import { makeRequest } from "@/utils/makeRequest";
import { useState } from "react";
import { toast } from "sonner";

interface WithdrawPayload {
  assetId: string;
  amount: string;
  destinationAddress: string;
  otp: string;
  securityCode: string;
}

const UserWithdrawal = () => {
  const [loading, setLoading] = useState(false);

  const { user } = useAppSelector((state) => state.auth);
  const userId = user?.id;

  const {
    data: myWallet,
    isLoading,
    isError,
    refetch,
  } = useMyWalletAndAssets(userId!);

  const withdraw = async (payload: WithdrawPayload) => {
    setLoading(true);

    try {
      await makeRequest.post("/withdrawal", payload);

      toast.success("Withdrawal initiated");

      // if (response) {
      //   navigate("/dashboard/transactions");
      // }

      await refetch();
    } catch (error) {
      toast.error(getErrorMessage(error));

      // Important:
      // rethrow so WithdrawContainer knows
      // that the withdrawal failed.
      throw error;
    } finally {
      setLoading(false);
    }
  };

  if (isLoading) {
    return <Loader type="bounce" />;
  }

  if (isError || !myWallet) {
    return (
      <ErrorState
        onRetry={() => {
          refetch();
        }}
      />
    );
  }

  return (
    <WithdrawContainer
      wallet={myWallet}
      assets={myWallet.assets}
      loading={loading}
      onWithdraw={withdraw}
    />
  );
};

export default UserWithdrawal;
